<script setup lang="ts">
import LGLoginForm from "~/components/user/LGLoginForm.vue";
import LGRegistrationForm from "~/components/user/LGRegistrationForm.vue";

const { t } = useI18n()
const items = [
    {
        label: t('userProfile.login.login'),
        slot: 'login'
    },
    {
        label: t('userProfile.login.register'),
        slot: 'register'
    }
]

const title = t('userProfile.login.seo.title')
const description = t('userProfile.login.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'index,follow',
})

definePageMeta({
    layout: 'user',
    middleware: ['guest'],
})
</script>

<template>
    <UTabs :items="items">
        <template #login>
            <LGLoginForm/>
        </template>
        <template #register>
            <LGRegistrationForm/>
        </template>
    </UTabs>
</template>

<style scoped>

</style>
